var render = function () {
  var _vm$message;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "color": "grey-f7",
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-4 txt txt--sm txt--dark font-size-14 text-center"
  }, [_c('span', [_vm._v(" " + _vm._s((_vm$message = _vm.message) === null || _vm$message === void 0 ? void 0 : _vm$message.message) + " ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }